export default __webpack_public_path__ + "static/media/art3.4c20c99e.mp4";